class ViewSmartreviewReviewSubmission {

    //NOTE: Cannot declare variables at top of class like in Typescript. In plain ES6 JS Microsoft Edge will fail to parse the script (but not other browsers)

    constructor(target) {
        var thisObj = this;
        console.log('\nViewSmartreviewReviewSubmission script v1\n');

        //Assign elements
        this.target = target;

        //Assign the form button onclick disable code - have to re-do this since this page doesn't use the main layout
        console.log('Assigning form button click disable..');
        Apfco.disableFormButtonsOnSubmit(this.target);

        //Call various initialization methods
        this.initializeLinkHtmlElements();
        this.initializeFormChangeDetection();
        this.initializeDisableFormInput();

        console.log('Page script load complete.');
    }

    initializeLinkHtmlElements() {
        console.log('Linking elements..');
        this.Form = this.target.getElementsByTagName("Form")[0];
        this.FormFieldsChanged = document.getElementById("FormFieldsChanged");
        this.IsReadOnly = document.getElementById("IsReadOnly");
        this.IsReadOnlyValue = (this.IsReadOnly.value === 'True');
        this.SubPendingUpdatesMade = this.target.getElementsByClassName('SubPendingUpdatesMade')[0];
        this.SubBtnInvoiceEditList = this.target.querySelectorAll('.SubBtnUpdate');
        this.SubBtnUpdate = this.target.getElementsByClassName('SubBtnUpdate')[0];
        this.SubBtnProcess = this.target.getElementsByClassName('SubBtnProcess')[0];
        this.SubBtnHold = this.target.getElementsByClassName('SubBtnHold')[0];
        this.SubBtnVoid = this.target.getElementsByClassName('SubBtnVoid')[0];
        this.ReviewComment = this.target.querySelectorAll('textarea[name="ReviewComment"]')[0];
        this.SubBtnBack = this.target.getElementsByClassName('SubBtnBack')[0];
        this.ReviewNextAvailableSubmission = document.getElementById("ReviewNextAvailableSubmission");
    }

    initializeFormChangeDetection() {
        console.log('Initializing form change detection..');
        var thisObj = this;
        $(this.Form).find(":input").change(function () {
            thisObj.setFormFieldsChanged();
        });
        $(this.Form).find(".UnqualifiedReasonReviewer").find(":input").click(function () {
            thisObj.setFormFieldsChanged();
        }); $(this.Form).find(".UnqualifiedReasonAutoUnqualify").find(":input").click(function () {
            thisObj.setFormFieldsChanged();
        });
    }

    initializeDisableFormInput() {
        if (this.IsReadOnlyValue) {
            console.log('IsReadOnly set to true - disabling all inputs..');

            //Specifically only get the elements that are visisble controls (don't want to disable the anti-forgery token or other hidden fields)
            let elements = this.Form.querySelectorAll('input.form-control,input.btn,input.form-check-input,a.btn,select.form-control,textarea.form-control');
            for (var i = 0; i < elements.length; ++i) {
                if (elements[i]) {
                    (elements[i]).disabled = true;
                }
            }

            //Reset some specific elements as enabled as they should always be available
            for (let i = 0; i < this.SubBtnInvoiceEditList.length; ++i) {
                this.SubBtnInvoiceEditList[i].disabled = false;
            }
            if (this.SubBtnProcess) //May not be rendered
                this.SubBtnProcess.disabled = false;
            if (this.SubBtnHold) //May not be rendered
                this.SubBtnHold.disabled = false;
            if (this.SubBtnVoid) //May not be rendered
                this.SubBtnVoid.disabled = false;
            if (this.SubBtnClientReturn) //May not be rendered
                this.SubBtnClientReturn.disabled = false;
            this.SubBtnBack.disabled = false;
            if (this.ReviewNextAvailableSubmission) //May not be rendered
                this.ReviewNextAvailableSubmission.disabled = false;
        }
        else
            console.log('IsReadOnly set to false - leaving all inputs enabled..');
    }

    setFormFieldsChanged() {
        if (!this.IsReadOnlyValue) {
            console.log('Form fields changed.');
            this.FormFieldsChanged.value = 'True';
            this.SubPendingUpdatesMade.style.display = '';
        }
        else {
            console.log('Change occured but no edit/review allowed, no changes flagged');
        }

    }
}

//Instantiate on page load if matching HTML is found
let ViewSmartreviewReviewSubmissionList = [];
$(function () {
    if (document.body.classList.contains('cSmartreview') && document.body.classList.contains('aReviewSubmission')) {
        let elementsByClass = document.getElementsByClassName("viewWrapper");
        for (let i = 0; i < elementsByClass.length; i++) {
            ViewSmartreviewReviewSubmissionList.push(new ViewSmartreviewReviewSubmission(elementsByClass.item(i)));
        };
    }
});